export function initReviewsSmallSlider() {
	const el = document.querySelector(".section-reviews-small .reviews.swiper");
	if (!el || typeof window.Swiper === "undefined") return;

	new window.Swiper(el, {
		speed: 500,
		loop: true,
		slidesPerView: "auto",
		slidesPerView: 1,
		spaceBetween: 30,
		centeredSlides: true,
		pagination: {
			el: el.querySelector(".swiper-pagination"),
			clickable: true,
		},
		autoplay: {
			delay: 5000,
		},
		a11y: {
			slideRole: "article",
		},
		breakpoints: {
			0: {
				enabled: true,
				slidesPerView: 1,
			},
			768: {
				enabled: false,
			},
		},
	});
}
